import React, {useContext, useEffect, useState} from 'react';

import LazyLoading from "../../components/LazyLoading";
import {Col, Form, Modal, Row} from "@themesberg/react-bootstrap";
import fetchWrapper from "../../utils/fetch/fetchWrapper";
import {BASE_URL} from "../../config";
import {LOCAL_STORAGE} from "../../context/LocalStorage";
import DataTableExtensions from "react-data-table-component-extensions";
import DataTable from "react-data-table-component";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import 'react-data-table-component-extensions/dist/index.css';

const ModalDetails = ({showModal, setShowModal, id, setId}) => {

    const [dataDetails, setDataDetails] = useState({});
    const [dataOrder, setDataOrder] = useState({});
    const [dataHistoricStatus, setDataHistoricStatus] = useState({});


    let token = localStorage.getItem(LOCAL_STORAGE.AUTH_TOKEN)

    // const fetchDataModal = (event) => {
    //     axios({
    //         method: "get",
    //         url: BASE_URL + "/find_order_items",
    //         headers: {
    //             'Authorization': token
    //         },
    //         data: {
    //             id: id,
    //         },
    //         timeout: 1000
    //     })
    //         .then(function (response) {
    //             console.log(response.data);
    //             if ((response.data.status = 200)) {
    //                 setDataDetails(response.data.orderItems)
    //             }
    //         })

    //         .catch(function (error) {
    //             console.log(error);
    //         });
    // }

    useEffect(() => {
        if (showModal) {
            fetchWrapper()
          .doPost({
              url: "/find_order_items",
              body:{
                  id: id
              },
              onSuccess: async (response) => {
                  setDataDetails(response.data.orderItems)
                  setDataOrder(response.data.order)
                  setDataHistoricStatus(response.data.orderSequence)
              },
              onError: (response) => {
                  alert(response.data.message);
              },
              })
              .then(() => {
              })
              .catch((error) => {
              });
            // axios({
            //     method: "post",
            //     url: BASE_URL + "/find_order_items",
            //     headers: {
            //         'Authorization': token
            //     },
            //     data: {
            //         id: id,
            //     },
            //     timeout: 5000
            // })
            //     .then(function (response) {
            //         console.log(response.data);
            //         if ((response.data.status = 200)) {
            //             console.log(response.data)
            //             setDataDetails(response.data.orderItems)
            //             setDataOrder(response.data.order)
            //             setDataHistoricStatus(response.data.orderSequence)
            //         }
            //     })

            //     .catch(function (error) {
            //         console.log(error);
            //     });
        }

    }, [showModal]);

    // const dataOnChange = (e) => {
    //     setDataForm({
    //         ...dataForm,
    //         [e.target.name]: e.target.value
    //     })
    // }
    // const tableData = {
    //     columnItem,
    //     dataDetails
    // };
    const handleClose = () => {
        setShowModal(false);
        setId(null)
        // setDataForm({})
    }
    const columnsOrder = [
        {
            name: "Dirección",
            selector: "address",
            wrap: true,
            grow: 3
        },
        {
            name: "Total",
            cell: row => <>${new Intl.NumberFormat('de-DE').format(row.total)}</>,
            selector: "total",
        },
        {
            name: "SubTotal",
            cell: row => <>${new Intl.NumberFormat('de-DE').format(row.subtotal)}</>,
        },
        {
            name: "Despacho",
            cell: row => <>${new Intl.NumberFormat('de-DE').format(row.dispatch_price)}</>,
        },
        {
            name: "Fecha elegida",
            selector: "pickup_date",
            grow: 10,
        },
        {
            name: "Descuento",
            selector: "discount",
        },
        {
            name: "Codigo de Descuento",
            selector: 'discount_code',
            sortable: true,
            grow: 3,
        },
        {
            name: "Estado",
            selector: "state",
            wrap: true,
            grow: 2
        },
        {
            name: "Cliente",
            selector: "client",
            wrap: true,

        },
        {
            name: "Cleaner",
            selector: "employee",
            wrap: true,

        },
        {
            name: "Rut del Cleaner",
            selector: "employee_rut",
            wrap: true,
            grow: 1
        },
        {
            name: "Ganancias Cleaner",
            selector: "cleaner_profits",
        },
        {
            name: "Ganancias Seifrei",
            selector: "seifrei_profits",
        },
        {
            name: "Método de Pago",
            selector: "payment_type",
            cell: row => (
                row.payment_type === 'CASH' ? 'Efectivo' :
                row.payment_type === 'ETPAY' ? 'ETPay' :
                row.payment_type
              ),
        },
        {
            name: "Pagado",
            selector: "confirmed",
            cell: row => (
                row.confirmed === true ? 'Pagado':
                row.confirmed === false ? 'Sin Pagar':
                row.confirmed
            )
        },
        {
            name: 'Codigo',
            selector: 'confirmation_code',
        }
    ];
    const columnItem = [
        {
            name: "Nombre del item",
            selector: "name",
            sortable: true,
        },
        {
            name: "Servicio",
            selector: "service_title",
            sortable: true,
        },
        {
            name: "Precio total",
            cell: row => <>${new Intl.NumberFormat('de-DE').format(row.price)}</>,
            sortable: true,
        },
        {
            name: "Precio del servicio",
            cell: row => <>${new Intl.NumberFormat('de-DE').format(row.service_price)}</>,
            sortable: true,
        },
        {
            name: "Descripcion",
            selector: "description",
            sortable: true,
            wrap: true,
            grow: 1
        },
    ];
    const columnHistoricStatus = [

        {
            name: "Estado historico de la orden",
            selector: "status",
            sortable: true,
        },
        {
            name: "Secuencia",
            selector: "sequence",
            sortable: true,
        },
        {
            name: "Fecha",
            selector: "create",
            sortable: true,
        },
    ];
    return (
        <Modal show={showModal} onHide={() => handleClose()}

               size="xl"
               aria-labelledby="contained-modal-title-vcenter"
               centered
        >
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">
                    Detalles de la orden
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {/* <div className="row">
                    <div className="col-md-10">
                        <h4>ID: {id}</h4>
                    </div>
                    <div className="col-md-10">
                        <h4>Direccion: {dataOrder.address}</h4>
                    </div>
                    <div className="col-md-10">
                        <h4>Estado del pedido: {dataOrder.state}</h4>
                    </div>
                    <div >
                        <h5>Subtotal: ${dataOrder.subtotal}</h5>
                        <h5>Despacho: ${dataOrder.dispatch_price}</h5>
                        {dataOrder.discount == null ?
                            <>
                                <h5>Descuento: $0</h5>
                            </> : <>
                                <h5>Descuento: ${dataOrder.discount}</h5>
                            </>

                        }
                        <h5>Total: ${dataOrder.total}</h5>
                    </div>
                </div> */}
                <div>
                    <h4>Numero de orden: {id}</h4>
                </div>
                <DataTable
                    columns={columnsOrder}
                    data={dataOrder}
                />
                {/* <DataTableExtensions {...tableData}> */}
                <div className="row mt-5 ">
                    <h4>Secuencia historica de la orden:</h4>

                    <DataTable
                        columns={columnHistoricStatus}
                        data={dataHistoricStatus}
                    />
                </div>
                <div className="row mt-5 ">
                    <h4>Detalle de la orden:</h4>

                    <DataTable
                        columns={columnItem}
                        data={dataDetails}
                        pagination
                        noHeader
                        paginationPerPage={10}
                    />
                </div>
                {/* </DataTableExtensions> */}
                {/* <Row>
                    <Col md={12} className="mb-3">
                      <Form.Group id="firstName">
                        <Form.Label>Categoria</Form.Label>
                        <Form.Control onChange={dataOnChange} value={dataForm.hasOwnProperty("title") ? dataForm.title : ''} name="title" type="text" placeholder="Ingresa tu categoria" required/>
                      </Form.Group>
                    </Col>
                  </Row> */}
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-light" onClick={() => handleClose()}>Cerrar</button>
            </Modal.Footer>
        </Modal>


    );
};

export default ModalDetails
